import { RunConversationTurnUseCase } from './RunConversationTurnUseCase'
import { conversationRepository } from '../../../data-access/repositories'

export const runConversationTurn = new RunConversationTurnUseCase({
  conversationRepository,
}).execute
